jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

$('.coll-toggle span').on('click', function(){
    $('.coll-toggle span').removeClass('active')
    $(this).addClass('active');
     let readytoDeliver = $('span.ready-to-deliver').hasClass('active');
     if (readytoDeliver){
         $('.t4s_box_pr_grid.t4s-products').addClass('preorder');
     }else{
          $('.t4s_box_pr_grid.t4s-products').removeClass('preorder');
     }
});

$('.t4s-product-form__submit').on('click', function(){
  let quantity = $('.t4s-quantity-input').val();
  let max_qty = $('.max_quantity_to_take').val();
   let total_variant = $('.total_variants').val();
  if (max_qty < quantity && total_variant == 1){
    new_row = "<input type='hidden' class='availability_property' name='properties[Availability]' value='Pre-Order'>  ";
    $('.t4s-form__product').append(new_row);
  }else{
    $(".availability_property").remove();
  }
});